import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import { translate as t } from '../../lib/I18n';
import { StationTypes, SeasonStationTypes, SmartcardStationTypes, GenericModals } from '../../constants/AppConstants';
import Station from '../../records/Station';
import Search from '../../records/Search';
import SeasonSearch from '../../records/SeasonSearch';
import TrackingActions from "../../actions/TrackingActions";

import StationSelector from './StationSelector';
import BaseModal from '../general/BaseModal';
import Icon from '../general/Icon';
import PureRenderComponent from '../PureRenderComponent';


class ViaAvoidModal extends PureRenderComponent {

    static propTypes = {
        search: PropTypes.oneOfType([
            PropTypes.instanceOf(Search),
            PropTypes.instanceOf(SeasonSearch)
        ]).isRequired,
        show: PropTypes.bool.isRequired,
        season: PropTypes.bool,
        station: PropTypes.instanceOf(Station),
        viaAvoid: PropTypes.oneOf([ StationTypes.VIA, StationTypes.AVOID ]),
        onCancel: PropTypes.func,
        onSelect: PropTypes.func
    };

    static defaultProps = {
        season: false,
        station: null,
        viaAvoid: StationTypes.VIA,
        onCancel: _.noop,
        onSelect: _.noop
    };

    state = {
        station: this.props.station,
        viaAvoid: this.props.viaAvoid
    };

    _onSave = () => {
        this.props.onSelect(this.state.viaAvoid, this.state.station);
    };

    _handleViaAvoidChange = (event) => {
        this.setState({ viaAvoid: event.target.value });
    };

    _handleViaAvoidStationChange = (station) => {
        this.setState({ station });
    };

    _isDirty () {
        return this.props.station !== this.state.station &&
            this.props.viaAvoid !== this.state.viaAvoid;
    }

    _hasErrors () {
        return !this.state.station.nlc;
    }

    render () {
        const { viaAvoid } = this.state;
        const { search, season, show, onCancel } = this.props;
        const placeholder = viaAvoid === StationTypes.VIA
            ? t('booking.journey.viaPlaceholder')
            : t('booking.journey.avoidPlaceholder');
        const label = viaAvoid === StationTypes.VIA
            ? t('booking.journey.viaLabel')
            : t('booking.journey.avoidLabel');
        const modalProps = {
            show: show,
            onClose: onCancel,
            onContinue: this._onSave,
            closeText: 'button.text.cancel',
            continueText: 'button.text.select',
            disableBlur: this._isDirty(),
            disableContinue: this._hasErrors(),
            titleText: 'booking.journey.viaAvoid',
            className: 'modal--sm via-avoid-modal',
            onOpen: () => {
                TrackingActions.genericModalOpen(GenericModals.TRAVEL_VIA_AVOID);
            }
        };

        let stationType = null;
        if (search.get('smartcard')) {
            stationType = SmartcardStationTypes.VIAAVOID;
        } else if (season) {
            stationType = SeasonStationTypes.VIAAVOID;
        } else {
            stationType = StationTypes.VIAAVOID;
        }


        return (
            <BaseModal { ...modalProps }>
                <section className="modal-body__via-avoid clearfix">
                    <Row>
                        <Col xs={ 12 } sm={ 4 }>
                            <span className="select-container">
                                <Icon icon="dropdown" />

                                <label className="sr-only" htmlFor="via-avoid">
                                    { t('booking.journey.viaAvoid') }
                                </label>

                                <select
                                    name="viaAvoid"
                                    id="via-avoid"
                                    className="via-avoid__select"
                                    value={ viaAvoid }
                                    onChange={ this._handleViaAvoidChange }>
                                        <option value='via'>{ t('booking.journey.via') }</option>
                                        <option value='avoid'>{ t('booking.journey.avoid') }</option>
                                </select>
                            </span>
                        </Col>

                        <Col xs={ 12 } sm={ 8 }>
                            <span className="input-field input-field--autocomplete">
                                <StationSelector
                                    name="viaAvoidStation"
                                    label={ <span className="sr-only">{ label }</span> }
                                    station={ this.state.station }
                                    placeholder={ placeholder }
                                    onChange={ this._handleViaAvoidStationChange }
                                    stationType={ stationType }
                                />
                            </span>
                        </Col>
                    </Row>
                </section>
            </BaseModal>
        );
    }

}


export default ViaAvoidModal;



// WEBPACK FOOTER //
// ./src/components/search/ViaAvoidModal.js